import { render } from "./ChallengeBanner.vue?vue&type=template&id=d9d1dd4c"
import script from "./ChallengeBanner.vue?vue&type=script&lang=js"
export * from "./ChallengeBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__